'use strict';

var status = require('../../../../../../../../../../_virtual/status.cjs');

(function (exports) {

	exports.STATUS_INTENTIONS = void 0;
	(function(STATUS_INTENTIONS) {
	    STATUS_INTENTIONS["success"] = "success";
	    STATUS_INTENTIONS["system"] = "system";
	    STATUS_INTENTIONS["warning"] = "warning";
	    STATUS_INTENTIONS["info"] = "info";
	    STATUS_INTENTIONS["danger"] = "danger";
	})(exports.STATUS_INTENTIONS || (exports.STATUS_INTENTIONS = {}));
	
} (status.__exports));
//# sourceMappingURL=status.cjs.map
